import { createStore } from "vuex";
import { auth } from "./auth.module";

const debug = process.env.NODE_ENV !== "production";

const store = createStore({
  state() {
    return {
      //Configuration for microsoft SSO
      /*
      msalConfig: {
        auth: {
          //Key given by the Microsoft Azure application
          clientId: "4b28b0d5-a8d0-49a0-b856-458d137b00b1",
          //Determine what kind of microsoft account can access the site (Personal / professional / student)
          //Common let everyone sign-in
          authority: "https://login.microsoftonline.com/common/",
        },
        cache: {
          cacheLocation: "localStorage",
        },
      },*/
      accessToken: "",
      cart: [],
    };
  },
  getters: {
    cartCount: (state) => {
      return state.cart.length;
    },
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token;
    },
    setAuthUser(state, payload) {
      state.auth.user = payload;
    },
    addToCart(state, activity) {
      state.cart.push(activity);
    },
    removeFromCart(state, index) {
      state.cart.splice(index, 1);
    },
    emptyCart(state) {
      state.cart = [];
    },
    updateRepetitionActivity(state, { index, repetitions }) {
      state.cart[index].repetitions = repetitions; // Modifier uniquement via mutation
    },
    updateVersionNumberActivity(state, { index, versionNumber }) {
      state.cart[index].versionNumber = versionNumber; // Modifier uniquement via mutation
    },
  },
  actions: {
    updateRepetitionActivity({ commit }, payload) {
      commit("updateRepetitionActivity", payload); // Déclencher la mutation via une action
    },
    updateVersionNumberActivity({ commit }, payload) {
      commit("updateVersionNumberActivity", payload); // Déclencher la mutation via une action
    },
  },
  modules: {
    auth,
  },
  strict: debug,
});

export default store;
